import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
    {
        path: '/about',
        name: 'about',
        component: () => import ('@/views/about/index'),
        meta: { title: '關於我們' },
    },
    {
        path: '/h5about',
        name: 'h5about',
        component: () => import ('@/views/about/indexh5'),
        meta: { title: '關於我們' },
    },
    {
        path: '/en/h5about',
        name: 'enabout',
        component: () => import ('@/views/about/enh5'),
        meta: { title: 'about us' },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import ('@/views/privacy/index'),
        meta: { title: '隱私協定' },
    },
    {
        path: '/h5privacy',
        name: 'h5privacy',
        component: () => import ('@/views/privacy/indexh5'),
        meta: { title: '隱私協定' },
    },
    {
        path: '/h5privacy/en',
        name: 'h5privacyen',
        component: () => import ('@/views/privacy/indexh5'),
        meta: { title: '隱私協定' },
    },
    {
        path: '/en/h5privacy',
        name: 'enh5privacy',
        component: () => import ('@/views/privacy/enh5'),
        meta: { title: 'privacy' },
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import ('@/views/agreement/index'),
        meta: { title: '使用者協定' },
    },
    {
        path: '/h5agreement',
        name: 'h5agreement',
        component: () => import ('@/views/agreement/indexh5'),
        meta: { title: '使用者協定' },
    },
    {
        path: '/en/h5agreement',
        name: 'enh5agreement',
        component: () => import ('@/views/agreement/enh5'),
        meta: { title: 'agreement' },
    },
    {
        path: '/problem/cn/:id',
        name: 'index',
        component: () => import ('@/views/problem/index'),
        meta: { title: '支付問題' },
    },
    {
        path: '/h5problem/cn/:id',
        name: 'index',
        component: () => import ('@/views/problem/indexh5'),
        meta: { title: '支付問題' },
    },
]

const router = new Router({
    mode: "hash",
    routes,
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        window.location.reload();
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js